import type React from "react";
import { Send } from "lucide-react";
import { i18n } from "@frontend/i18n";
import { Button } from "@planta-v2/pds-ui/button";
import { useDirectoryExportSectionController } from "../controllers/useDirectoryExportSectionController";
import { DirectoryExportModal } from "./DirectoryExportModal";

/**
 * Offers the directory as a spreadsheet from Preferences (D1). Porter delivers it over
 * WhatsApp: the browser download this replaced produced no file at all inside
 * WhatsApp's in-app viewer, which is where most members open the app.
 */
export function DirectoryExportSection(): React.JSX.Element | null {
  const { state, actions } = useDirectoryExportSectionController();
  const { isVisible, modalState, includeWhyConnect } = state;

  if (!isVisible) return null;

  return (
    <section data-testid="directory-export-section" className="px-4 pt-4">
      <p className="mb-2 text-pds-micro font-medium uppercase leading-none tracking-[0.08em] text-muted-foreground">
        {i18n.t("user.profile.preferences.export.sectionLabel")}
      </p>
      <div className="rounded-md border border-foreground/15 bg-card p-4">
        <h2 className="font-serif text-base font-normal text-foreground">
          {i18n.t("user.profile.preferences.export.title")}
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {i18n.t(
            includeWhyConnect
              ? "user.profile.preferences.export.description"
              : "user.profile.preferences.export.descriptionNoWhyConnect",
          )}
        </p>
        <Button
          variant="outline"
          size="sm"
          onClick={actions.openConfirmation}
          data-testid="directory-export-cta"
          className="mt-3 gap-1"
        >
          <Send className="h-4 w-4" />
          {i18n.t("user.profile.preferences.export.button")}
        </Button>
      </div>
      <DirectoryExportModal
        state={modalState}
        onClose={actions.closeModal}
        onConfirm={actions.sendExport}
      />
    </section>
  );
}
